import { cn } from "@repo/utils/cn";
import { tv } from "tailwind-variants";

export const sectionWrapperAuto = tv({
  base: cn("uipm:mx-auto"),
  variants: {
    backgroundColor: {
      none: "uipm:bg-[var(--surface-surface-primary)]",
      light: "uipm:bg-[var(--surface-surface-secondary)]",
      accent: "uipm:bg-[var(--surface-surface-accent-secondary)]",
      "accent-light": "uipm:bg-[var(--surface-surface-accent-light)]",
    },
    topPadding: {
      none: "uipm:pt-0",
      default: "uipm:pt-[var(--container-section-top)]",
      large: "uipm:pt-[var(--container-section-top-large)]",
    },
    bottomPadding: {
      none: "uipm:pb-0",
      default: "uipm:pb-[var(--container-section-bottom)]",
      large: "uipm:pb-[var(--container-section-top-large)]",
    },
    pageType: {
      default: "",
      location: "uipm:lg:max-w-[920px]",
      article: "",
    },
  },
  defaultVariants: {
    backgroundColor: "none",
    topPadding: "none",
    bottomPadding: "none",
    pageType: "default",
  },
});

export const sectionWrapperFull = tv({
  base: cn("uipm:w-full"),
  variants: {
    backgroundColor: {
      none: "uipm:bg-[var(--surface-surface-primary)]",
      light: "uipm:bg-[var(--surface-surface-secondary)]",
      accent: "uipm:bg-[var(--surface-surface-accent-secondary)]",
      "accent-light": "uipm:bg-[var(--surface-surface-accent-light)]",
    },
    topPadding: {
      none: "uipm:pt-0",
      default: "uipm:pt-[var(--container-section-top)]",
      large: "uipm:pt-[var(--container-section-top-large)]",
    },
    bottomPadding: {
      none: "uipm:pb-0",
      default: "uipm:pb-[var(--container-section-bottom)]",
      large: "uipm:pb-[var(--container-section-top-large)]",
    },
    pageType: {
      default: "",
      location: "",
      article: "",
    },
  },
  defaultVariants: {
    backgroundColor: "none",
    topPadding: "none",
    bottomPadding: "none",
    pageType: "default",
  },
});

export const sectionWrapper = sectionWrapperAuto;
